module.exports = __webpack_public_path__ + "components/advertise-contact/static/premium-incentive-background-e40b508eca8cf7ce73b9401d2c1182de.jpg";